export default "__VITE_ASSET__DqMnWxc2__"